import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, AppState } from './types';

// The `withTypes` guard is load-bearing: tests that mock react-redux supply a
// bare useDispatch/useSelector without it.
// biome-ignore lint/plugin: withTypes constrains to redux's Dispatch, which AppDispatch is not. See AppAction in store/types.ts.
export const useAppDispatch = (
  'withTypes' in useDispatch ? useDispatch.withTypes() : useDispatch
) as () => AppDispatch;

export const useAppSelector =
  'withTypes' in useSelector ? useSelector.withTypes<AppState>() : useSelector;
